export const useGetQueryParam = (param: string) =>
  location.href.split(param)?.[1]?.replace(/%3D/g, '=')
